import { ToolsPage } from "templates";

const Tools = () => {

  document.title = "Tools | ADMIN PGK";

  return (
    <>
      <ToolsPage/>
    </>
  )
}

export default Tools